import { MigrationManifest, PersistedState } from "redux-persist";

export const migrations: MigrationManifest = {
  2: function (state) {
    const { _persist } = state as PersistedState & {
      pwaIOS: {
        isShow: true;
        closed_at: null;
      };
    };

    return { _persist };
  },
};
